/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./sidebar/Sidebar";

function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    handleResize();

    if (window.location.pathname === "/layout" || window.location.pathname === "/layout/") {
      navigate(localStorage.currentModuleUrl ?? "/");
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="tw-flex">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <main
        className={`tw-flex-grow transition-all duration-300 ${
          isSidebarOpen ? "tw-ml-72" : "tw-ml-20"
        }`}
        style={{ padding: "20px", overflow: "auto" }}
      >
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
